import { ENDPOINTS } from '../../constants/api'
import { madeRequest } from '../../helpers/api'

// PLOP_APPEND_PATTERN_ANCHOR
export function getTikTokRegionsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.tikTokRegions
  })
}

export async function getTikTokPixelsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.tikTokPixels
  })
}

export async function getTikTokIdentitiesService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.tikTokIdentities
  })
}

export function getTikTokInterestsService(params) {
  return madeRequest('GET', {
    url: ENDPOINTS.tikTokInterests,
    params
  })
}

export function getTikTokActionCategoriesService(params) {
  return madeRequest('GET', {
    url: ENDPOINTS.tikTokActionCategories,
    params
  })
}

export function getTikTokHashtagsService(params) {
  return madeRequest('GET', {
    url: ENDPOINTS.tikTokHashtags,
    params
  })
}

export function getTikTokCustomAudiencesService(params) {
  return madeRequest('GET', {
    url: ENDPOINTS.tikTokCustomAudiences,
    params
  })
}

export function getTikTokVideoService({ id, account }) {
  return madeRequest('GET', {
    params: { account },
    url: `${ENDPOINTS.tikTokVideos}${id}/`
  })
}

export function getTikTokVideoThumbnailsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.tikTokVideoThumbnails
  })
}

export function getTikTokContentExclusionCategoriesService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.tikTokContentExclusionCategories
  })
}

export function getAdditionalInterestCategoriesService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.tikTokTargetingSearch
  })
}

export function getTikTokPurchaseIntentionCategoriesService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.tikTokTargetingSearch
  })
}

export function getAdditionalInterestCategoriesByIdsService(data) {
  return madeRequest('POST', {
    data,
    url: ENDPOINTS.tikTokInterestKeywords
  })
}

export function getPurchaseIntentionCategoriesByIdsService(data) {
  return madeRequest('POST', {
    data,
    url: ENDPOINTS.tikTokInterestKeywords
  })
}
